(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.statecoursedesignatorwa = skyward.statecoursedesignatorwa || {};

        var init = function (selector)
        {
            var curricYearDetailsScreenSelector = $(selector).find("#editCurriculumYear.currentRecordContent.dataObjectViewer");
            var courseDetailsScreenSelector = $(selector).find("#editCourse.currentRecordContent.dataObjectViewer");
            var studentSectionDetailsScreenSelector = $(selector).find("#StudentSectionWADOV.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");

            var stateCourseDesignatorSelectEEL;
            var isDetails;
            var pageSelector;
            var controlAppend = "";
            var useControlAppendForSettingValues = false;
            var numericYearFieldName;

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAID";
            var vocationalTypeCodeComboBox;

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
            };

            var vocationalTypeCodeOnChange = function ()
            {
                skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, false);
            };

            if (curricYearDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = curricYearDetailsScreenSelector.find("#editCurriculumYear_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }

                vocationalTypeCodeComboBox = curricYearDetailsScreenSelector.find('#editCurriculumYear_VocationalTypeCode');
                if (vocationalTypeCodeComboBox.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, true);
                    vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                }
            }
            else if (courseDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = courseDetailsScreenSelector.find("#editCourse_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCourse_";
                    numericYearFieldName = "NumericSchoolYearFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (studentSectionDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = studentSectionDetailsScreenSelector.find("#StudentSectionWADOV_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#StudentSectionWADOV_";
                    stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAIDOverride";
                    stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAIDOverride";
                    stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAIDOverride";
                    numericYearFieldName = "SchoolYearNumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (workflowScreenSelector.length > 0)
            {
                isDetails = false;

                if (workflowScreenSelector.find("#D6992DF2-7D2C-4F99-9931-4774941AC99B").length > 0)
                {
                    // Curriculum workflow
                    pageSelector = "#CurriculumYearWA";
                    controlAppend = "CurriculumYearWA";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find("#E4AA0295-910D-498C-B97B-B9AA39185FD0").length > 0)
                {
                    // Curriculum Year workflow
                    pageSelector = "#CurriculumYear";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                    vocationalTypeCodeComboBox = workflowScreenSelector.find(pageSelector + "VocationalTypeCode");

                    if (vocationalTypeCodeComboBox.length > 0)
                    {
                        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(workflowScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox);
                        vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                    }
                }
                else if (workflowScreenSelector.find("#3F20F9EE-7217-4C32-8215-7262E58C91ED").length > 0)
                {
                    // Course workflow
                    pageSelector = "#Course";
                    controlAppend = "Course";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericSchoolYearFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find('#2004CB53-23B1-40C3-B63C-92889D29112A').length > 0)
                {
                    // Transfer Course workflow
                    var ChildRecordQuickEntryStateCourseDesignatorOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange(this);
                    };

                    var stateCourseDesignatorSelectEELs = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                    if (stateCourseDesignatorSelectEELs.length)
                    {
                        stateCourseDesignatorSelectEELs.each(function ()
                        {
                            skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange($(this));
                            $(this).on("change", ChildRecordQuickEntryStateCourseDesignatorOnChange);
                        });
                    }

                    // place event on StateALECourseTypeWA to hide/show state online codes
                    var stateALECourseTypeWACodeEELValues = workflowScreenSelector.find(".statealecoursetypewacodeeel");
                    if (stateALECourseTypeWACodeEELValues.length > 0)
                    {
                        var stateCourseDesignators = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                        stateALECourseTypeWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateALECourseTypeWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);

                            var stateALECourseTypeWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);
                            };
                            stateALECourseTypeWACodeEEL.on("codeEELValuesUpdated", stateALECourseTypeWAOnChange);

                            // place event on the change of the _value so when this value is cleared from dependecies the stateALECourseTypeWAOnChange is ran again to hide the labels
                            control.on("change", stateALECourseTypeWAOnChange);
                        });
                    }

                    // place event on UseStateCIPOverride to hide/show state industry certification
                    var useStateCIPWAIDOverrideValue = workflowScreenSelector.find(".usestatecipoverridecheckbox");
                    if (useStateCIPWAIDOverrideValue.length > 0)
                    {
                        useStateCIPWAIDOverrideValue.each(function ()
                        {
                            var control = $(this);
                            var useStateCIPWAIDOverride = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);
                            };
                            useStateCIPWAIDOverride.on("click", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCIPOverrideEEL to hide/show state industry certification
                    var stateCIPWAIDOverrideCodeEELValues = workflowScreenSelector.find(".statecipoverridecodeeel");
                    if (stateCIPWAIDOverrideCodeEELValues.length > 0)
                    {
                        stateCIPWAIDOverrideCodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCIPWAIDOverrideCodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
                            };
                            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCTECourseEquivalency to hide/show StateCTEEquivaencyCodeWA's label, added child sections is covered in stateCourseDesignatorChildRecordSectionAdd function
                    var stateCTECourseEquivalencyWACodeEELValues = workflowScreenSelector.find(".statectecourseequivalencycodeeel");
                    if (stateCTECourseEquivalencyWACodeEELValues.length > 0)
                    {
                        stateCTECourseEquivalencyWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCTECourseEquivalencyWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);

                            var stateCTECourseEquivalencyWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
                            };
                            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

                            // place event on the change of the _value of cte course equivalency so when this value is cleared from dependecies the stateCTECourseEquivalencyWACodeOnChange is ran again to hide the field
                            control.on("change", stateCTECourseEquivalencyWAOnChange);
                        });
                    }

                    // place event on child record add button to run this again when a new child section is made
                    var childRecordAddButton = workflowScreenSelector.find("#childrecordquickentryaddbutton-studentsection-studentid-1");
                    var stateCourseDesignatorChildRecordSectionAdd = function ()
                    {
                        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend, useControlAppendForSettingValues);
                    };
                    childRecordAddButton.on("click", stateCourseDesignatorChildRecordSectionAdd);
                }
                else if (workflowScreenSelector.find('#1376135B-4FCE-4D83-B56F-E6767BBEEB58').length > 0)
                {
                    // Mass Change Course Master Workflow
                    pageSelector = "#MassUpdateCourseMaster";
                    controlAppend = "";
                    stateAdvancedPlacementFieldName = "Update-CourseWAStateAdvancedPlacementCodeWAID";
                    stateInternationalBaccalaureateFieldName = "Update-CourseWAStateInternationalBaccalaureateCodeWAID";
                    stateCambridgeInternationalFieldName = "Update-CourseWAStateCambridgeInternationalCodeWAID";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#Update-CourseStateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYearForFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

                    var stateALECourseTypeWACodeEEL = workflowScreenSelector.find("#Update-SectionWAStateALECourseTypeWAID");
                    var stateALECourseTypeWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL);
                    };
                    stateALECourseTypeWACodeEEL.on("change", stateALECourseTypeWAOnChange);

                    var stateSequenceFieldset = $("#fsStateSequenceWAID");
                    if (stateSequenceFieldset.length > 0)
                    {
                        stateSequenceFieldset.hide()
                    }
                    
                    var sequenceGroupWAEEL = workflowScreenSelector.find("#Update-CourseWASequenceGroupWAID");
                    var sequenceGroupWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange(sequenceGroupWAEEL);
                    };
                    sequenceGroupWAEEL.on("change", sequenceGroupWAOnChange);
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName)
        {
            var numericYear = isDetails ? $(pageSelector + numericYearFieldName).val() : $("#" + numericYearFieldName).val();
            var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
            var selectedDesignatorIDList;

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");
            var stateCICheckbox = $("#SelectedField-CourseWAStateCambridgeInternationalCodeWAID");

            if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
            {
                selectedDesignatorIDList = Object.keys(JSON.parse(selectedStateCourseDesignators));
            }

            var stateDesignatorCodeAPID = isDetails ? $(pageSelector + "StateDesignatorCodeAPID").data('original-value') : $("#StateDesignatorCodeAPID" + controlAppend).data('original-value');
            var stateDesignatorCodeIBID = isDetails ? $(pageSelector + "StateDesignatorCodeIBID").data('original-value') : $("#StateDesignatorCodeIBID" + controlAppend).data('original-value');
            var stateDesignatorCodeCIID = isDetails ? $(pageSelector + "StateDesignatorCodeCIID").data('original-value') : $("#StateDesignatorCodeCIID" + controlAppend).data('original-value');
            var stateDesignatorCodeOID = isDetails ? $(pageSelector + "StateDesignatorCodeOID").data('original-value') : $("#StateDesignatorCodeOID" + controlAppend).data('original-value');
            var stateDesignatorCodeCID = isDetails ? $(pageSelector + "StateDesignatorCodeCID").data('original-value') : $("#StateDesignatorCodeCID" + controlAppend).data('original-value');
            var stateDesignatorCodeTID = isDetails ? $(pageSelector + "StateDesignatorCodeTID").data('original-value') : $("#StateDesignatorCodeTID" + controlAppend).data('original-value');

            var stateAPFieldset;
            var stateIBFieldset;
            var stateCIFieldset;

            var hEISelected = numericYear >= 2027 && stateDesignatorCodeCID !== undefined && ($.inArray(stateDesignatorCodeCID.toString(), selectedDesignatorIDList) !== -1 || $.inArray(stateDesignatorCodeTID.toString(), selectedDesignatorIDList) !== -1);

            if (hEISelected)
            {
                stateHEIFieldset = isDetails ? $(pageSelector + "fsStateHigherEducationInstitutionWAID") : $("#fsStateHigherEducationInstitutionWAID" + controlAppend);
                stateHEIFieldset.show();
            }
            else
            {
                var stateHEIFieldset = isDetails ? $(pageSelector + "fsStateHigherEducationInstitutionWAID") : $("#fsStateHigherEducationInstitutionWAID" + controlAppend);
                stateHEIFieldset.hide();
                var setValuePrefix = isDetails ? pageSelector : "#";
                skyward.controls.setValue(setValuePrefix + "StateHigherEducationInstitutionWASelectEEL" + (useControlAppendForSettingValues ? controlAppend : ""), null);
            }

            if (selectedDesignatorIDList !== undefined && selectedDesignatorIDList.length === 0 || !stateDesignatorCodeAPID || !stateDesignatorCodeIBID || (numericYear >= 2027 && stateDesignatorCodeCIID !== undefined && !stateDesignatorCodeCIID))
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetOnlineFields(isDetails, pageSelector, controlAppend);

                return;
            }

            var aPSelected = $.inArray(stateDesignatorCodeAPID.toString(), selectedDesignatorIDList) !== -1;
            var iBSelected = $.inArray(stateDesignatorCodeIBID.toString(), selectedDesignatorIDList) !== -1;
            var cISelected = numericYear >= 2027 && stateDesignatorCodeCIID !== undefined && $.inArray(stateDesignatorCodeCIID.toString(), selectedDesignatorIDList) !== -1;
            var oSelected = stateDesignatorCodeOID !== undefined && $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

            StateOnlineCodesActions(isDetails, pageSelector, controlAppend, oSelected);

            var moreThanOneSelected = [aPSelected, iBSelected, cISelected].reduce((count, value) => count + Number(value), 0) > 1;
            if (moreThanOneSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);

                return;
            }

            if (aPSelected)
            {
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
                stateAPFieldset.show();

                if (stateAPCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateAPCheckbox, "true");
                }

                return;
            }

            if (iBSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
                stateIBFieldset.show();

                if (stateIBCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateIBCheckbox, "true");
                }

                return;
            }

            if (cISelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateCIFieldset = isDetails ? $(pageSelector + "fsStateCambridgeInternationalCodeWAID") : $("#fsStateCambridgeInternationalCodeWAID" + controlAppend);
                stateCIFieldset.show();

                if (stateCICheckbox.length > 0)
                {
                    skyward.controls.setValue(stateCICheckbox, "true");
                }

                return;
            }

            ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
            ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
            ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);

            return;
        };

        var StateOnlineCodesActions = function (isDetails, pageSelector, controlAppend, oSelected)
        {
            var numericYear = isDetails ? $(pageSelector + "SchoolYearNumericYear").data('original-value') : $("#NumericYearForFilter" + controlAppend).data('original-value');
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0 && oSelected)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019 && (stateALECourseTypeWACodeValue === "O"))
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    skyward.controls.setValue(providerCheckbox, "true");
                }

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.show();
                stateOnlineProgramNonRequired.hide();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.show();
                stateOnlineProviderNonRequired.hide();
            }
            else
            {
                ResetOnlineFields(isDetails, pageSelector, controlAppend);
            }
        };

        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange = function (stateCourseDesignatorSelectEEL)
        {
            var select = $(stateCourseDesignatorSelectEEL);
            var controlID = select.attr("Id").split("-").pop();
            var controlAppend = "-add-" + controlID;
            var useControlAppendForSettingValues = true;

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAID";
            var isDetails = false;
            var pageSelector = "#";
            var numericYearFieldName = "NumericYearForFilter" + controlAppend;

            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, select, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
        }

        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues)
        {
            var newSectionID = $("table").find("tr").last().attr("Id")?.split("-").pop() ?? "";
            controlAppend = "-add-" + newSectionID;
            stateCourseDesignatorSelectEEL = $("table").find("#StateCourseDesignatorsWASelectEEL" + controlAppend);
            var numericYearFieldName = "NumericYearForFilter" + controlAppend;
            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
            };
            stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

            var stateCTECourseEquivalencyWACodeEEL = $("table").find("#StateCTECourseEquivalencyWAID" + controlAppend);
            var stateCTECourseEquivalencyWAOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
            };
            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

            var stateCTECourseEquivalencyWACodeEELValue = stateCTECourseEquivalencyWACodeEEL.first("input");
            stateCTECourseEquivalencyWACodeEELValue.on("change", stateCTECourseEquivalencyWAOnChange)

            var useStateCIPOverride = $("table").find("#UseStateCIPOverride" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPOverride);
            };
            useStateCIPOverride.on("click", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEEL = $("table").find("#StateCIPWAID" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
            };
            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEELValue = stateCIPWAIDOverrideCodeEEL.first("input");
            stateCIPWAIDOverrideCodeEELValue.on("change", stateCIPOverrideOnChange)
        };

        skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange = function (stateCTECourseEquivalencyWACodeEEL)
        {
            var sectionDiv = stateCTECourseEquivalencyWACodeEEL.parent().parent();
            var controlID = stateCTECourseEquivalencyWACodeEEL.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            var stateCTEEquivalencyWAFieldSet = sectionDiv.find("#StateCTEEquivalencyCodeWA" + controlID);

            var stateCTECourseEquivalencyWACodeValue = sectionDiv.find("#StateCTECourseEquivalencyWAID" + controlID + "_code").val();
            var stateCTECourseEquivalencyWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateCTECourseEquivalencyWAOverride" + controlID));

            if (stateCTECourseEquivalencyWACheckBoxValue === true && (stateCTECourseEquivalencyWACodeValue === "A" || stateCTECourseEquivalencyWACodeValue === "B") && numericYear >= 2018)
            {
                stateCTEEquivalencyWAFieldSet.show();
            }
            else
            {
                stateCTEEquivalencyWAFieldSet.hide();
                skyward.controls.setValue("#StateCTEEquivalencyCodeWAID" + controlID, null);
            }
        };

        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange = function (stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL)
        {
            var numericYear = $('#NumericYearForFilter' + controlID).val();
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019)
            {
                var sectionDiv = stateALECourseTypeWACodeEEL.parent().parent();
                var controlID = stateALECourseTypeWACodeEEL.attr("Id").split("-").pop();
                controlID = "-add-" + controlID;

                var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
                var selectedDesignatorIDList;
                if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
                {
                    selectedDesignatorIDList = Object.keys(JSON.parse(selectedStateCourseDesignators));
                }

                var stateDesignatorCodeOID = $("#StateDesignatorCodeOID" + controlID).data('original-value');
                var oSelected = $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

                var programCheckbox = sectionDiv.find("#UseStateOnlineProgramOverride" + controlID);
                var stateOnlineProgramRequired = sectionDiv.find("#RequiredOnlineProgramLabel" + controlID);
                var stateOnlineProgramNonRequired = sectionDiv.find("#NotRequiredOnlineProgramLabel" + controlID);

                var providerCheckbox = sectionDiv.find("#UseStateOnlineProviderOverride" + controlID);
                var stateOnlineProviderRequired = sectionDiv.find("#RequiredOnlineProviderLabel" + controlID);
                var stateOnlineProviderNonRequired = sectionDiv.find("#NotRequiredOnlineProviderLabel" + controlID);

                var stateALECourseTypeWACodeValue = sectionDiv.find("#StateALECourseTypeWAID" + controlID + "_code").val();
                var stateALECourseTypeWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateALECourseTypeWAOverride" + controlID));

                if ((stateALECourseTypeWACheckBoxValue === true && stateALECourseTypeWACodeValue === "O") || oSelected)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                    skyward.controls.setValue(providerCheckbox, "true");

                    stateOnlineProgramRequired.show();
                    stateOnlineProgramNonRequired.hide();

                    stateOnlineProviderRequired.show();
                    stateOnlineProviderNonRequired.hide();
                }
                else
                {
                    stateOnlineProgramRequired.hide();
                    stateOnlineProgramNonRequired.show();

                    stateOnlineProviderRequired.hide();
                    stateOnlineProviderNonRequired.show();
                }
            }

            return;
        };

        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange = function (sequenceGroupWAEEL)
        {
            var numericYear = $("#NumericYearForFilter").data('original-value');
            if (numericYear > 2021)
            {
                var stateSequenceCheckbox = $("#SelectedField-CourseWAStateSequenceWAID");
                var stateSequenceFieldset = $("#fsStateSequenceWAID");
                var sequenceGroupWAValue = skyward.controls.getValue(sequenceGroupWAEEL);

                if (sequenceGroupWAValue !== "" && sequenceGroupWAValue !== undefined)
                {
                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "true");
                    }

                    stateSequenceFieldset.show();
                }
                else
                {
                    stateSequenceFieldset.hide();
                    var sectionDiv = sequenceGroupWAEEL.parent().parent();
                    var stateSequenceWAEEL = sectionDiv.find("#Update-CourseWAStateSequenceWAID")
                    skyward.controls.setValue(stateSequenceWAEEL, null);

                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "false");
                    }
                }
            }

            return;
        };

        var ResetAPFields = function (stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
            stateAPFieldset.hide();
            skyward.controls.setValue(pageSelector + stateAdvancedPlacementFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            if (stateAPCheckbox.length > 0)
            {
                skyward.controls.setValue(stateAPCheckbox, "false");
            }
        };

        var ResetIBFields = function (stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
            stateIBFieldset.hide();
            skyward.controls.setValue(pageSelector + stateInternationalBaccalaureateFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");
            if (stateIBCheckbox.length > 0)
            {
                skyward.controls.setValue(stateIBCheckbox, "false");
            }
        };

        var ResetCIFields = function (stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateCIFieldset = isDetails ? $(pageSelector + "fsStateCambridgeInternationalCodeWAID") : $("#fsStateCambridgeInternationalCodeWAID" + controlAppend);
            stateCIFieldset.hide();
            skyward.controls.setValue(pageSelector + stateCambridgeInternationalFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateCICheckbox = $("#SelectedField-CourseWAStateCambridgeInternationalCodeWAID");
            if (stateCICheckbox.length > 0)
            {
                skyward.controls.setValue(stateCICheckbox, "false");
            }
        };

        var ResetOnlineFields = function (isDetails, pageSelector, controlAppend)
        {
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();
            if (stateALECourseTypeWACodeValue !== undefined && stateALECourseTypeWACodeValue !== "O")
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);
                var stateOnlineProgramFieldName = isDetails ? "StateOnlineProgramWAIDOverride" : "StateOnlineProgramWAID";
                var stateOnlineProviderFieldName = isDetails ? "StateOnlineProviderWAIDOverride" : "StateOnlineProviderWAID";

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.hide();
                stateOnlineProgramNonRequired.show();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.hide();
                stateOnlineProviderNonRequired.show();

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    skyward.controls.setValue(pageSelector + stateOnlineProgramFieldName + controlAppend, null);
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    skyward.controls.setValue(pageSelector + stateOnlineProviderFieldName + controlAppend, null);
                }

                var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
                var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
                if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateOnlneProgramCheckbox, "false");
                    skyward.controls.setValue(stateOnlineProviderCheckbox, "false");
                }
            }
        };

        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange = function (screenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, runOnLoad)
        {
            var stateCIPNonRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelNonRequired') : $(pageSelector + 'StateCIPWAIDLabelNonRequired');
            var stateCIPRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelRequired') : $(pageSelector + 'StateCIPWAIDLabelRequired');
            var numericYear = isDetails ? screenSelector.find(pageSelector + 'NumericYear').val() : $('#NumericYear').val();
            var vocationalTypeCodeNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeNotRequired') : $('#VocationalTypeCodeNotRequired');
            var vocationalTypeCodeRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeRequired') : $('#VocationalTypeCodeRequired');

            if (stateCIPNonRequiredLabel.length > 0 && stateCIPRequiredLabel.length > 0)
            {
                if (vocationalTypeCodeComboBox.val() === "B")
                {
                    stateCIPNonRequiredLabel.show();
                    stateCIPRequiredLabel.hide();

                    var stateCIPWACodeEel = pageSelector + "StateCIPWAID";

                    if (!runOnLoad)
                    {
                        skyward.controls.setValue(stateCIPWACodeEel, null);

                        skyward.controls.setValue('#SelectedStateCertificationWAEELDictionary', null);
                        var industryRecognizedCertificationsFieldSet = isDetails ? pageSelector + 'fsIndustryRecognizedCertifications' : 'fsIndustryRecognizedCertifications'
                        skyward.controls.hide(industryRecognizedCertificationsFieldSet);

                        skyward.controls.setValue('#SelectedWorkBasedLearningActivityWAEELDictionary', null);
                        var stateWorkBasedLearningActivitesWAFieldSet = isDetails ? pageSelector + 'fsStateWorkBasedLearningActivitesWA' : 'fsStateWorkBasedLearningActivitesWA'
                        skyward.controls.hide(stateWorkBasedLearningActivitesWAFieldSet);
                    }

                    var stateCTECourseEquivalencyNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'NotRequiredCTECourse') : $('#NotRequiredCTECourse');
                    var stateCTECourseEquivalencyRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'RequiredCTECourse') : $('#RequiredCTECourse');

                    if (stateCTECourseEquivalencyNotRequiredLabel.length > 0 && stateCTECourseEquivalencyRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "")
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.show();
                            stateCTECourseEquivalencyRequiredLabel.hide();
                        }
                        else
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.hide();
                            stateCTECourseEquivalencyRequiredLabel.show();
                        }
                    }

                    if (vocationalTypeCodeNotRequiredLabel.length > 0 && vocationalTypeCodeRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "" || numericYear < 2018)
                        {
                            vocationalTypeCodeNotRequiredLabel.show();
                            vocationalTypeCodeRequiredLabel.hide();
                        }
                        else
                        {
                            vocationalTypeCodeNotRequiredLabel.hide();
                            vocationalTypeCodeRequiredLabel.show();
                        }
                    }
                }
                else
                {
                    if (numericYear < 2018)
                    {
                        vocationalTypeCodeNotRequiredLabel.show();
                        vocationalTypeCodeRequiredLabel.hide();
                    }
                    stateCIPNonRequiredLabel.hide();
                    stateCIPRequiredLabel.show();
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCIPOverrideOnChange = function (controlFiredFrom)
        {
            var sectionDiv = controlFiredFrom.parent().parent();
            var controlID = controlFiredFrom.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            var parentStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWADesc" + controlID));
            var overrideStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWAID" + controlID + "_code"));
            var useOverrideStateCIP = skyward.controls.getValue(sectionDiv.find("#UseStateCIPOverride" + controlID));

            if (numericYear > 2020)
            {
                if (useOverrideStateCIP && overrideStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else if (!useOverrideStateCIP && parentStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else
                {
                    skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                    skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
                }
            }
            else
            {
                skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
            }

            if (numericYear >= 2022)
            {
                if (useOverrideStateCIP && overrideStateCIPValue !== "")
                {
                    skyward.controls.show("#fsStateWorkBasedLearningActivitesWA" + controlID);
                }
                else if (!useOverrideStateCIP && parentStateCIPValue !== "")
                {
                    skyward.controls.show("#fsStateWorkBasedLearningActivitesWA" + controlID);
                }
                else
                {
                    skyward.controls.hide("#fsStateWorkBasedLearningActivitesWA" + controlID);
                    skyward.controls.setValue("#SelectedWorkBasedLearningActivityWAEELDictionary" + controlID, null);
                }
            }
            else
            {
                skyward.controls.hide("#fsStateWorkBasedLearningActivitesWA" + controlID);
                skyward.controls.setValue("#SelectedWorkBasedLearningActivityWAEELDictionary" + controlID, null);
            }

            return;
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);